import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPendingCrest = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 253.22 296.1",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
		d: "M126.61 296.1c-40.5 0-75.27-19.85-100.55-57.41C7.47 211.08.59 183.72.31 182.57L0 180.05V46.04L126.61 0l126.61 46.04-.31 136.53c-.28 1.15-7.16 28.51-25.75 56.12-25.28 37.56-60.05 57.41-100.55 57.41M21.1 178.68C24.25 190.29 49.91 275 126.61 275s102.35-84.7 105.51-96.32V60.82L126.61 22.45 21.1 60.82v117.87Z",
		className: "cls-1"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M126.61 42.88 42.2 74.53v105.51c9.21 19.9 33.25 64.41 75.54 72.69 2.84.56 5.79.95 8.86 1.16 3.07-.21 6.02-.61 8.86-1.16 42.3-8.27 66.33-52.79 75.54-72.69V74.53l-84.41-31.65Z",
		className: "cls-1"
	})] })
});
export default SvgPendingCrest;
